import { useState } from 'react';
import { useSelector } from 'react-redux';
import DiscoveryButtonsEditor from '../../DiscoveryButtonsEditor';
import AccordionSection from './accordionSection/AccordionSection';
import DesignColorsSection from './designColorsSection/DesignColorsSection';
import DesignImagesSection from './designImagesSection/DesignImagesSection';
import DesignTextsSection from './designTextsSection/DesignTextsSection';
import classes from './DesignTab.module.css';

const DesignTab = ({
  domainName,
  botName,
  draft,
  setDraft,
  discoveryButtons,
  onDiscoveryButtonsChange,
  originalImageUrls,
  descriptions,
  modalContainer,
  onSubjectSelect,
}) => {
  const { texts } = useSelector(state => state.translate);
  const [openSections, setOpenSections] = useState({
    colors: false,
    images: false,
    texts: false,
    discovery: false,
  });

  const toggleSection = key => {
    setOpenSections(current => ({
      ...current,
      [key]: !current[key],
    }));
  };

  return (
    <div className={classes.List}>
      <AccordionSection
        title={`${texts.sectionColors} (${botName})`}
        isOpen={openSections.colors}
        onToggle={() => toggleSection('colors')}
      >
        <DesignColorsSection
          draft={draft}
          setDraft={setDraft}
          descriptions={descriptions}
        />
      </AccordionSection>
      <AccordionSection
        title={texts.sectionImages}
        isOpen={openSections.images}
        onToggle={() => toggleSection('images')}
      >
        <DesignImagesSection
          domainName={domainName}
          botName={botName}
          draft={draft}
          setDraft={setDraft}
          originalImageUrls={originalImageUrls}
          descriptions={descriptions}
        />
      </AccordionSection>
      <AccordionSection
        title={texts.sectionTextsAndFields}
        isOpen={openSections.texts}
        onToggle={() => toggleSection('texts')}
      >
        <DesignTextsSection
          draft={draft}
          setDraft={setDraft}
          descriptions={descriptions}
          onSubjectSelect={onSubjectSelect}
        />
      </AccordionSection>
      <AccordionSection
        title={texts.discoveryButtonsSection}
        isOpen={openSections.discovery}
        onToggle={() => toggleSection('discovery')}
      >
        <DiscoveryButtonsEditor
          botName={botName}
          domainName={domainName}
          draft={draft}
          buttons={discoveryButtons}
          onChange={onDiscoveryButtonsChange}
          descriptions={descriptions}
          modalContainer={modalContainer}
        />
      </AccordionSection>
    </div>
  );
};

export default DesignTab;
